import { useMemo } from 'react';
import { isNullish } from 'remeda';
import { useMergeTargetSearch } from 'src/components/MergeTargetPicker/use-merge-target-search';
import { ConditionInput, EntityNames } from 'src/graphql/types';

/** Clients of one partner, optionally without the merge origin. */
export const useClientTargetSearch = ({
  partnerId,
  excludedClientId,
}: {
  partnerId?: number | null;
  excludedClientId?: string;
}) => {
  const conditions = useMemo(() => {
    const list: ConditionInput[] = [];

    if (!isNullish(partnerId)) {
      list.push({ attribute: 'partnerId', operator: '=', value: partnerId.toString() });
    }

    if (excludedClientId) {
      list.push({ attribute: 'clientId', operator: 'not_in', value: excludedClientId });
    }

    return list;
  }, [partnerId, excludedClientId]);

  return useMergeTargetSearch({ entityName: EntityNames.Client, conditions });
};
